<template>
  <main>
    <div id="container">
      <h1>HiperMe</h1>
      <img class="login__hiperme-logo" src="/images/hiperme_isologo_miscelanias.png" width="100" />
      <div class="content">
        <Transition name="fade" mode="out-in">
          <router-view class="view" />
        </Transition>
      </div>
    </div>
    <div class='side-info' :style="{ backgroundImage: 'url(' + src + ')' }" :class="{ 'art' : src }">
    </div>
  </main>
</template>

<script>
import http from '@/api/http'
export default {
  data() {
    return {
      src: ''
    }
  },
  beforeMount() {
    http.get(`side_images/active`).then(({ data }) => {
      this.src = data ? process.env.VUE_APP_API_HOST.replace("/api", "") + "" + data.fullPath : "";
    })
  }
}
</script>

<style scoped>
main {
  background-color: white;
  display: inline-flex;
  width: 100vw;
  height: 100vh;
}

h1 {
  display: none;
}

h1 + img {
  position: absolute;
  top: var(--column);
  bottom: var(--column);
}

#container {
  width: 50vw;
  background-color: white;
  display: flex;
  flex-direction: column;
  position: relative;
}

.content {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  flex: 1;
}

.view {
  width: 60%;
  min-width: 450px;
}

.fade-enter, 
.fade-leave-to {
  opacity: 0;
  transform: translateX(-2em);
}

.fade-enter-active, 
.fade-leave-active {
  transition: all .3s ease;
}

.side-info {
    width: 50vw;
    background-color: var(--green-50);
}

.side-info.art {
  background-color: transparent;
  background-position: right;
  background-repeat: repeat-y;
  background-size: contain;
}

@media only screen and (max-width: 1366px) {
  .view {
    width: 60%;
    min-width: 250px;
  }
}

@media only screen and (max-width: 1024px) {
  h1 + img {
    position:initial;
    display: block;
    margin: 0 auto;
  }

  #container {
    width: 100vw;
  }

  .view {
    width: 95%;
  }

  .side-info {
    display: none;
  }
}

@media screen and (max-height: 500px) {
  .login__hiperme-logo {
    width: 70px;
  }
  
}
</style>